var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Model } from "vue-property-decorator";
import { Subject } from "@/models/Subject";
import { WorksheetModel } from "@/models/Worksheet";
import ErrorHandler from "@/support/ErrorHandler";
import LoaderCard from "@/components/loader-card/LoaderCard.vue";
import EditableTextarea from '@/components/EditableTextarea/EditableTextarea';
import { RolesEnum } from '@/items/Roles';
let Worksheet = class Worksheet extends Vue {
    constructor() {
        super(...arguments);
        // #endregion
        // #region @PropSyncs
        // #endregion
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = false;
        this.worksheet = '';
        this.worksheetOptions = this.getWorksheet();
        this.currentStep = 1;
        this.worksheetPrompts = {
            basePrompt: '',
            prompt: '',
            worksheet_type: '',
        };
        // #endregion
        // #region Event handlers
        // #endregion
        // #region Class methods
        this.strategyTypes = [
            'Geen', 'Rijgend', 'Splitsend', 'Cijferend', 'Meervoudig optellen', 'Kolomsgewijs delen', 'Vermenigvuldigen'
        ];
        this.rules = {
            required: (value) => !!value || 'This field is required',
            minMaxQuestions: (value) => {
                const num = typeof value === 'string' ? Number(value) : value;
                return (num >= 1 && num <= 40) || 'Number must be between 1 and 40';
            },
            minMaxTime: (value) => {
                const num = typeof value === 'string' ? Number(value) : value;
                return (num >= 1 && num <= 90) || 'Number must be between 1 and 90';
            },
        };
        // #endregion
        // #region @Watchers
        // #endregion
        // #region Enums
        // #endregion
        // #region Interfaces
        // #endregion
        // #region Constants
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.mapSubjectToWorksheetOptions();
    }
    mapSubjectToWorksheetOptions() {
        this.worksheetOptions.subject = this.subject.name;
    }
    getWorksheet() {
        return {
            subject: undefined,
            group: undefined,
            worksheet_type: 'document',
            question_count: '10',
            sum_type: 'Kale som',
            sum: 'Kale som zonder antwoord',
            answer_type: 'Cijfer',
            strategy: 'Geen',
            maximum_time: false,
            time: '',
            starting_example: false,
            has_to_check: false,
            check_types: {
                per_question: false,
                show_percentage: false,
                no_retry: false,
                answer_visibility: 'hide',
            },
            additional_prompt: ''
        };
    }
    newWorksheet() {
        this.worksheet = '';
        this.getWorksheet();
    }
    openWorksheet() {
        if (this.worksheet) {
            window.open(this.worksheet, '_blank');
        }
    }
    downloadWorksheet() {
        fetch(this.worksheet)
            .then((res) => {
            if (!res.ok) {
                throw new Error("Network Problem");
            }
            return res.blob();
        })
            .then((file) => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(file);
            link.download = this.worksheetOptions.worksheet_type === 'app' ? 'werkblad.html' : 'werkblad.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }
    mapOptionsToPayload() {
        const payload = {
            worksheet_type: this.worksheetOptions.worksheet_type,
            question_count: Number(this.worksheetOptions.question_count),
            subject: this.worksheetOptions.subject,
            sum_type: this.worksheetOptions.sum_type === 'Kale som' ? this.worksheetOptions.sum : this.worksheetOptions.sum_type,
            answer_type: this.worksheetOptions.answer_type,
            strategy: this.worksheetOptions.strategy,
            maximum_time: this.worksheetOptions.maximum_time ? Number(this.worksheetOptions.time) : undefined,
            group: this.levelValue,
            starting_example: this.worksheetOptions.starting_example,
            has_to_check: this.worksheetOptions.worksheet_type === 'app' ? this.worksheetOptions.has_to_check : undefined,
            additional_prompt: this.worksheetOptions.additional_prompt,
            ...(this.worksheetOptions.has_to_check ? { check_types: {
                    per_question: this.worksheetOptions.check_types.per_question,
                    show_percentage: this.worksheetOptions.check_types.show_percentage,
                    no_retry: this.worksheetOptions.check_types.no_retry,
                    answer_visibility: this.worksheetOptions.check_types.answer_visibility
                } } : {})
        };
        return payload;
    }
    // #endregion
    // #region Async methods (api calls only)
    submit() {
        this.isLoading = true;
        const payload = this.mapOptionsToPayload();
        new WorksheetModel()
            .generateWorksheet(payload)
            .then((response) => {
            this.worksheetPrompts.worksheet_type = response.worksheet_type;
            this.worksheetPrompts.basePrompt = response.basePrompt;
            this.worksheetPrompts.prompt = response.prompt;
            if (this.canSeeApp)
                this.currentStep = 2;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
        if (!this.canSeeApp) {
            setTimeout(() => {
                this.submitPrompts();
            }, 200);
        }
        this.isLoading = false;
    }
    submitPrompts() {
        this.isLoading = true;
        const payload = this.mapOptionsToPayload();
        new WorksheetModel()
            .create({ ...this.worksheetPrompts, worksheet_type: this.worksheetPrompts.worksheet_type, })
            .then((response) => {
            this.worksheet = response.worksheet;
            this.isLoading = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
            this.isLoading = false;
        });
    }
    // #endregion
    // #region Getters & Setters
    get isDownloaded() {
        return !!this.worksheet;
    }
    get isDigital() {
        return !!this.worksheetOptions.has_to_check === true;
    }
    get canSeeApp() {
        return !!this.$store.state.Auth.hasRole([RolesEnum.ROOT]);
    }
    // these two functions are to prevent a typing error
    get levelName() {
        if (this.subject.level) {
            if (typeof this.subject.level === 'string') {
                const level = this.subject.level;
                return level;
            }
            else {
                const level = this.subject.level;
                return level.name;
            }
        }
    }
    get levelValue() {
        if ((typeof this.subject.level !== 'string' && this.subject.level)) {
            return Number(this.subject.level.value);
        }
        return 0;
    }
};
__decorate([
    Model('subject'),
    __metadata("design:type", typeof (_a = typeof Subject !== "undefined" && Subject) === "function" ? _a : Object)
], Worksheet.prototype, "subject", void 0);
Worksheet = __decorate([
    Component({
        components: {
            LoaderCard,
            EditableTextarea,
        },
    })
], Worksheet);
export default Worksheet;
